import React from 'react';
import PropTypes from 'prop-types';

import {
  STRING_FIELD_EDUCATION_MAJOR,
} from '../labels';

import FormikLabeledField from './FormikLabeledField';

import formikPropTypes from './formikPropTypes';

export function MajorField({
  name, formikProps,
}) {
  return (
    <FormikLabeledField
      name={name}
      formikProps={formikProps}
      label={STRING_FIELD_EDUCATION_MAJOR}
      placeholder={STRING_FIELD_EDUCATION_MAJOR}
    />
  );
}

MajorField.propTypes = {
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
};

export default MajorField;
